module.exports = __webpack_public_path__ + "img/share-whatsapp.05ed5741.svg";